import { Center, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import type { IconProps } from "@tabler/icons-react";
import type { ComponentType, ReactNode } from "react";

interface EmptyStateProps {
  icon?: ComponentType<IconProps>;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <Center py="var(--axio-unit-56)" px="md">
      <Stack align="center" gap="md" maw="var(--axio-unit-420)">
        {Icon && (
          <ThemeIcon size="var(--axio-unit-48)" variant="light" color="gray">
            <Icon size="var(--axio-unit-24)" stroke="var(--axio-stroke-width-subtle)" />
          </ThemeIcon>
        )}
        <Title order={4} ta="center">
          {title}
        </Title>
        {description != null && (
          <Text c="dimmed" size="sm" ta="center" lh="var(--axio-line-height-loose)">
            {description}
          </Text>
        )}
        {action}
      </Stack>
    </Center>
  );
}
